<template>
  <div class="page-login">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="box">

          <div class="tabs is-centered">
            <ul>
              <li class="is-active"><router-link to="/login">Login</router-link></li>
              <li><router-link to="/register">Sign Up</router-link></li>
            </ul>
          </div>

          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="login-form form-horizontal">

                <div class="control notification is-danger" v-if="error">
                  <button class="delete" @click="error = undefined"></button>
                  {{ error }}
                </div>

                <form-input
                  type="email" name="email"
                  fa="user" mdi="person_outline"
                  placeholder="Email"
                  :value="credentials.email"
                  @onInput="onInput"
                  :error="errors.email"
                  required=true
                  autofocus=true>
                </form-input>

                <form-input
                  type="password" name="password"
                  fa="lock" mdi="lock_outline"
                  placeholder="Password"
                  :value="credentials.password"
                  @onInput="onInput"
                  :error="errors.password"
                  required=true>
                </form-input>

                <p class="control has-text-centered">
                    <input id="checkbox" class="styled" v-model="rememberMe"
                      type="checkbox">
                    <label for="checkbox">
                        &nbsp;&nbsp;Remember Me
                    </label>
                </p>

                <p class="control submit">
                  <button class="button is-primary is-outlined is-fullwidth"
                    @click="submit()"
                    :class="{ 'is-loading': isLoading }">
                    Login
                  </button>
                </p>
              </div>
            </div>
          </div>

          <div class="extra">
            <p class="has-text-centered">
              <a href="{ route('password.request') }">Forgot password</a>
              &nbsp;&nbsp;&nbsp;
              <a href="#">Need help?</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      rememberMe: false,
      credentials: {
        email: 'admin@noctorus.net',
        password: '123456'
      },
      isLoading: false,
      error: '',
      errors: []
    }
  },
  methods: {
    submit () {
      this.error = ''
      this.errors = []
      this.isLoading = true

      auth.login(this.credentials)
      .then(data => {
        this.isLoading = false
        this.$router.push('/dashboard')
      })
      .catch(error => {
        console.error('login failed', error)
        if (error.error && typeof error.error === 'object') {
          this.errors = error.error
        } else if (error.error && typeof error.error === 'string') {
          this.error = error.error
        }

        this.isLoading = false
      })
    },
    onInput ({ name, value }) {
      if (!name || !this.credentials.hasOwnProperty(name)) {
        console.error('invalid update key: ' + name)
        return
      }
      this.credentials[name] = value
    }
  },
  created () {
    console.log('created login.vue')
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-login {
}
</style>



// WEBPACK FOOTER //
// Login.vue?180cbb1a